import type { ReactNode } from "react";
import { PRODUCT_NAME } from "../utils/productName";
import { BrandMark } from "./BrandMark";

interface AppShellProps { children: ReactNode; announcement?: string; online: boolean; onPrivacy: () => void }

export function AppShell({ children, announcement = "", online, onPrivacy }: AppShellProps) {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <div className="live-region" aria-live="polite" aria-atomic="true">{announcement}</div>
      {!online && (
        <div className="offline-banner" role="status">
          <strong>You’re offline.</strong> You can review this page, but calculating, saving, and changing reminders need a connection.
        </div>
      )}
      <header className="topbar">
        <a className="brand" href="/" aria-label={`${PRODUCT_NAME}, home`}>
          <BrandMark />
          <span>{PRODUCT_NAME}</span>
        </a>
        <span className="topbar__scope">Fast profile</span>
      </header>
      <main id="main-content" className="main" tabIndex={-1}>{children}</main>
      <footer className="footer">
        <p>Estimates only — not a bill or tax advice. We do not make legal or benefit-eligibility decisions.</p>
        <a href="/privacy" onClick={(event) => { event.preventDefault(); onPrivacy(); }}>Privacy details</a>
      </footer>
    </div>
  );
}
